import { onMount } from "solid-js";
import _ from "underscore";
import { Link, useNavigate, useRouteData } from "@solidjs/router";
import { fetchPost, scrollToTop } from "../library/common";
import { ImageFileData } from "../components/universal/image-cropper";
import { ArtworkImageData } from "../types";
import { Progress } from "../components/progress";
import { createStore } from "solid-js/store";
import toast from "solid-toast";
import { CMS } from "../components/cms/cms";
import { ModelImageCropper, ModelProvider } from "../components/model-form-elements";
import { useForm } from "../components/universal/validation";

export function EditImage() {  
    const url = {
        saveArtworkImage: "/LivingArtistApplication/SaveArtworkImageJson"
    };
    const page = {
        step2: () => "/step-2"
    }
    const notify = {
        artworkNotReceived: () => toast.error("Artwork data was not retrieved. Please refresh the page."),
        imageRequired: () => toast.error("There is no image selected to upload."),
        imageUploadError: (toastId: string) => toast.error("There was an error uploading the image.", { id: toastId }),
        imageSaved: (toastId: string, artworkImage: ArtworkImageData) => toast.success(`Image of "${artworkImage.Artwork.Title}" has been saved!`, { id: toastId }),
        imageUploading: () => toast.loading("Uploading the image ...")
    };
    const { formSubmit, validate, errors, setErrors } = useForm({
        errorClass: "error-input"
    });  
    const navigate = useNavigate();
    const [model, setModel] = createStore<ArtworkImageData>({} as ArtworkImageData);
    const toArtworkImageData = (artworkId: string, imageFile: ImageFileData) => {
        let _model = {
            ArtworkImageId: model.Id,
            IsPrimary: model.IsPrimary,
            ArtworkId: artworkId || "",
            NewImageId: model.NewImage?.Id || "",
            ImageFile: imageFile.image,
            OriginalFilename: imageFile.filename
        };
        return _model;
    };
    const saveImage = async (imageFile: ImageFileData) => {
        const _model = toArtworkImageData(model.Artwork.Id, imageFile);
        const toastId = notify.imageUploading();
        const res = await fetchPost(url.saveArtworkImage, _model);
        const json = await res.json();
        if (!json.Success) {
            return notify.imageUploadError(toastId);
        }
        notify.imageSaved(toastId, model);
        navigate(page.step2());
    }
    const onSaveClicked = async (e: Event) => {
        e.preventDefault();
        if (model.Artwork.Id === undefined) {
            return notify.artworkNotReceived()
        }
        const imageFile = await model.ImageEditor?.getImageFile();
        if (imageFile == null) {
            return notify.imageRequired()
        }
        await saveImage(imageFile);
    }
    onMount(async () => {
        const routeData = await useRouteData() as ArtworkImageData;
        setModel(routeData);
        if (routeData.NewImage?.URL) {
            setModel("ImageUrl", routeData.NewImage.URL);
        }
        scrollToTop();
    });
    return (
        <>
            <div>
                <Progress step={2}></Progress>
                <ModelProvider model={model} setModel={setModel} validation={{ errors, validate }}>
                    <CMS id="scholarship-application/edit-artwork::images/instructions">
                        <h4>
                            Images
                        </h4>
                        <p>
                            Images should be in either JPEG or PNG format and should be between 1MB and 10MB in size, each.
                        </p>
                    </CMS>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row" style="border: 1px solid #ccc; padding: 30px; margin: 0px; margin-top: 25px; border-radius: 10px;">
                                <div class="col-md-12">
                                    <div>
                                        <label style="font-size: 1.5em;">
                                            <CMS id="label::image">Image</CMS>
                                        </label>
                                        <ModelImageCropper<ArtworkImageData>
                                            imageUrl="ImageUrl"
                                            editor="ImageEditor"
                                            required
                                        />
                                    </div>                                
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <Link href={page.step2()} class="btn btn-default">Cancel</Link>
                            <button class="btn btn-primary" onClick={onSaveClicked}>Save</button>
                        </div>
                    </div>
                </ModelProvider>
            </div>
        </>
    );
}